module.exports = __webpack_public_path__ + "static/media/videocam-off-32px.342a0624.svg";